import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { ArrowRight } from "lucide-react";

export default function ProductCard({ product }) {
  const { priceText, catLabel, t, tr, L } = useLang();
  const img = product.images?.[0];

  return (
    <Link to={`/producto/${product.slug}`} data-testid={`product-card-${product.slug}`} className="group block">
      <div className="relative aspect-[4/5] overflow-hidden bg-vorna-elevated">
        <img src={img} alt={product.name} loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        {product.featured && (
          <span className="absolute top-3 left-3 border border-white/40 text-white text-[10px] font-bold px-2 py-1 tracking-widest">
            {tr("DESTACADO", "FEATURED")}
          </span>
        )}
        <span className="absolute bottom-0 left-0 right-0 translate-y-full group-hover:translate-y-0 transition-transform duration-300 bg-white text-black py-3 text-center font-display text-xs uppercase tracking-widest flex items-center justify-center gap-2">
          {t("more_info")} <ArrowRight className="h-3 w-3" />
        </span>
      </div>
      <div className="mt-3 flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="text-[10px] tracking-widest text-white/40 uppercase">{catLabel(product.category)}</p>
          <h3 className="font-semibold text-sm truncate group-hover:text-vorna-accent transition-colors mt-0.5">{L(product, "name")}</h3>
          <div className="mt-1.5 flex items-center gap-1.5">
            {product.colors?.slice(0, 4).map((c) => (
              <span key={c.name} className="h-3 w-3 rounded-full border border-white/20" style={{ backgroundColor: c.hex }} title={c.name} />
            ))}
          </div>
        </div>
        <span className="font-display text-xs text-right shrink-0 text-white/70">{priceText(product.price)}</span>
      </div>
    </Link>
  );
}
